import React from "react";
import EsenyurtSidebar from "../Sidebar/EsenyurtSidebar";
import EsenyurtOtherServices from "../ServiceAreas/EsenyurtServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const EsenyurtIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        ESENYURT HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Esenyurt gibi yoğun nüfuslu bir ilçede hijyenik yaşam alanları oluşturmak her geçen gün daha önemli hale gelmektedir. Halı, koltuk ve ev tekstil ürünlerinin düzenli ve profesyonel temizlikle bakımı, hem sağlık hem de yaşam kalitesi açısından büyük fayda sağlar.
          </p>

          <p>
            Esenyurt Halı Yıkama olarak, tam otomatik makinelerde yapılan halı temizliği, kumaş türüne özel koltuk yıkama sistemleri ve yerinden teslimat hizmetimizle %100 müşteri memnuniyetini hedefliyoruz. Alerji riskini azaltmak, bakteri ve akarları ortadan kaldırmak için antibakteriyel temizlik maddeleri kullanıyoruz.
          </p>

          <p>
            <strong>Hizmetlerimizin bazı avantajları şunlardır:</strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Esenyurt’un tüm mahallelerine ücretsiz servis</li>
            <li>Halı ve koltuklar için ayrı özel yıkama programları</li>
            <li>Organik deterjanlar ile güvenli temizlik</li>
            <li>Yorgan, battaniye, perde ve yatak yıkama imkanı</li>
            <li>72 saat içinde teslim garantisi</li>
            <li>Özel paketleme sistemi ile steril teslimat</li>
          </ul>

          <p>
            Pınar, Cumhuriyet, Talatpaşa, Mehterçeşme gibi Esenyurt'un birçok mahallesinde aktif hizmet sağlıyoruz. Siparişlerinizi aynı gün alıyor, planlı şekilde teslim ediyoruz.
          </p>

          <p>
            Profesyonel ekibimizle hijyenik, hızlı ve kaliteli temizlik hizmeti almak için bize hemen ulaşabilirsiniz. Web sitemiz ya da telefon numaramız üzerinden detaylı bilgi alabilir ve sipariş oluşturabilirsiniz.
          </p>

          {/* Mahalle sidebar ve hizmet bölgeleri */}
          <EsenyurtSidebar />
          <EsenyurtOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default EsenyurtIntro;
